import { Injectable } from '@angular/core';

import { HttpClient } from '../_services/global-http.service';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { GoogleMapsKey } from '../app.config';

import { environment } from '../../environments/environment';
import { combineLatest, distinctUntilChanged, map, catchError } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';
import { Address } from 'app/_models/address';

export interface User {
  gender: string;
  name: {
    first: string;
    last: string;
  }
}

export interface Pagination {
  selectedSize: number;
  currentPage: number;
  pageSizes: number[];
}

export interface RandomUserResponse {
  results: User[];
}


export interface HelpState {
  customer: Customer;
  faq_list: FaqList[];
  logo: string;
  breakdown_phone_number: string;
  accident_reporting_enabled: boolean;
  management_company: ManagementCompany;
  qr_code: QrCode;
  vehicle: any;
  vehicle_groups: any;
  is_dpd_local: boolean;
  loading: boolean;
  error: string;
}

export interface Customer {
  id: number;
  insurance: Object;
  maintenance_control: Object;
  locale: string;
  logo: string;
  logo_icon: string;
  name: string;
}
export interface FaqList {
  customer: number;
  description: any[];
  driver_category: DriverCategory;
  id: number;
  management_company: any;
  title: string;
}

export interface DriverCategory {
  id: number;
  display_name: string;
  category: string;
}
export interface ManagementCompany {
  accident_report_email: string;
  accident_reporting_enabled: boolean;
  faqs: any[];
  id: number;
  logo: string;
  name: string;
  slug: string;
  hide_vehicle_group_contacts: boolean;
  msc_insurance_name: string;
  msc_insurance_description: string;
  msc_insurance_address: Address;
  msc_insurance_phone: string;
  msc_insurance_url: string;
  msc_insurance_accident_phone: string;
}

export interface QrCode {
  id: number;
  external_vehicle_id: string;
  external_hashed_id: string;
  created_date_time: string;
  batch_number: string;
}
let _state: HelpState = {
  customer: null,
  faq_list: null,
  management_company: null,
  breakdown_phone_number: null,
  accident_reporting_enabled: true,
  logo: null,
  qr_code: null,
  vehicle: null,
  vehicle_groups: null,
  is_dpd_local: false,
  loading: true,
  error: null
};



@Injectable()
export class VehiclesHelpQrService {
  private store = new BehaviorSubject<HelpState>(_state);
  private state$ = this.store.asObservable();

  // customer$      = this.state$.pipe(map(state => state.customer), distinctUntilChanged());
  // criteria$   = this.state$.pipe(map(state => state.criteria), distinctUntilChanged());
  // pagination$ = this.state$.pipe(map(state => state.pagination), distinctUntilChanged());
  // loading$    = this.state$.pipe(map(state => state.loading));

  /**
   * Viewmodel that resolves once all the data is ready (or updated)...
   */
  vm$: Observable<HelpState> = this.state$;




  public sendDataTo: any;
  data: any;
  remData: any;

  constructor(private http: HttpClient, private googleMapsKey: GoogleMapsKey) {
  }

  initialData(qrCode: string) {

    forkJoin([
      this.getRemainingData(qrCode).pipe(
        catchError(err => {
          // Handle specific error for this call
          const error = err.status === 404 ? 'Customer data could not be found' : 'An error occurred getting customer information';
          this.updateState({ ..._state, error });
          console.log(err, 'Could not get getRemainingData() data');
          return of(undefined);
        })),
      this.getFaqList(qrCode).pipe(
        catchError(err => {
          // Handle specific error for this call
          const error = err.status === 404 ? 'FAQ data could not be found' : 'An error occurred getting FAQ information';
          this.updateState({ ..._state, error });
          console.log(err, 'Could not get getFaqList() data');
          return of(undefined);
        })),
      this.getQrDetailsNoAuth(qrCode).pipe(
        catchError(err => {
          // Handle specific error for this call
          const error = err.status === 404 ? 'QR Code data could not be found' : 'An error occurred getting QR Code information';
          this.updateState({ ..._state, error });
          console.log(err, 'Could not get getQrDetailsNoAuth() data');
          return of(undefined);
        }))
    ]).subscribe(results => {
      const dataCustomer = results[0];
      const dataFaq = results[1];
      const dataVehicle = results[2];
      // Logic with retrieved data
      if (dataCustomer && dataFaq && dataVehicle) {
        const customer = results[0]['customer'];
        const management_company = results[0]['management_company'];
        const faq_list = management_company && management_company.faqs ? management_company.faqs : results[1]['faq_list']['faq'];

        const qr_code = results[2]['qr_code'];
        const vehicle = results[2]['vehicle'];

        const vehicle_groups = results[2]['vehicle_groups'];
        const accident_reporting_enabled = management_company && management_company.accident_reporting_enabled
          ? management_company.accident_reporting_enabled : true;
        const breakdown_phone_number = management_company && management_company.break_down_phone
          ? management_company.break_down_phone : (customer.maintenance_control && customer.maintenance_control.phone);
        const logo = management_company && management_company.logo ? management_company.logo : customer.logo;
        const is_dpd_local = management_company && vehicle.livery_category.category_name === 'DPD Local' ? true : false;

        this.updateState({
          ..._state,
          customer, management_company, accident_reporting_enabled, breakdown_phone_number, logo,
          faq_list, qr_code, vehicle, vehicle_groups, is_dpd_local, loading: false
        });
      }
      this.updateState({ ..._state, loading: false });

    });
  }

  // Allows quick snapshot access to data for ngOnInit() purposes
  // getStateSnapshot(): HelpState {
  //   return {..._state, pagination: {..._state.pagination}};
  // }

  /** Update internal state cache and emit from store... */
  private updateState(state: HelpState) {
    this.store.next(_state = state);
    console.log('Help state: ', state);
  }


  //   getVehicleNoAuth(id: number) {
  //     this.data = this.http.get('/api/help/vehicle/'+id + '/');
  //     return this.data;
  //   }
  saveData(data) {
    this.sendDataTo = { ...this.sendDataTo, ...data };
  }
  getSaveData() {
    return this.store.getValue();
  }
  getQrDetailsNoAuth(qrid: string) {
    this.data = this.http.get('/api/help_qr_details/?qrid=' + qrid);
    return this.data;
  }

  getRemainingData(params: string) {
    this.remData = this.http.get('/api/more_help_qr_details/?qrid=' + params);
    return this.remData;
  }

  getFaqList(params: string) {
    return this.http.get('/api/faq_list_help_qr_details/?qrid=' + params);
  }

  getAccidentReporting() {
    const extAppKey: string = environment.externalAppKeys.dpd;
    return this.http.get('/api/help/vehicle/accident_reporting/', undefined, undefined, { 'Authorization': extAppKey });
  }
  postReport(data) {
    const extAppKey: string = environment.externalAppKeys.dpd;
    return this.http.post('/api/help/vehicle/accident_reporting/', data, { 'Authorization': extAppKey });
  }
  getLocation(latitude, longitude) {
    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${this.googleMapsKey.newKey}`, null, true)
  }
  getLatLong(address) {
    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${this.googleMapsKey.newKey}`, null, true)
  }
  getLatestDriverCheck(registration) {
    this.data = this.http.get(`/api/driver_check_latest/?registration=${registration}`);
    return this.data;
  }
  getLatestMOTCertCheck(registration) {
    this.data = this.http.get(`/api/document_latest/?registration=${registration}`);
    return this.data;
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/vehicle-help-qrcode.service.ts